// extracted by mini-css-extract-plugin
export var container = "_ge-0";
export var content = "_ge-3";
export var customerTitle = "_ge-4";
export var empty = "_ge-5";
export var gray = "_ge-6";
export var header = "_ge-7";
export var info = "_ge-8";
export var loading = "_ge-2";
export var loadingCard = "_ge-9";
export var oneLine = "_ge-a";
export var personName = "_ge-e";
export var pillContainer = "_ge-b";
export var selected = "_ge-1";
export var text = "_ge-c";
export var twoLines = "_ge-d";
export var unread = "_ge-f";
export var unreadIndicator = "_ge-g";